// Package Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );

const UserPerformance = lazy(
  () => import('pages/userPerformance/UserPerformance')
);
const UserPerfomanceRoute = (
  <Route path={routeName.userPerformanceReport}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.USER_PERFORMANCE_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <UserPerformance />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default UserPerfomanceRoute;
